
import { useState, useEffect } from "react";
import useFetch, { FetchRequest } from "../../../../../_helpers/UseFetchHook";
import { FetchResponse } from "../../../../../_helpers/Types";
import Reservation from "../../../../../Data/Reservation/Reservation";
import { Constants } from "../../../../../_helpers/Constants";
import Quote from "../../../../../Data/Quote/Quote";
import { PaymentAllocationCategory } from "../../../../../Data/Reservation/PaymentAllocationCategory";

const useCreateIndividualCategory = (request?: CreateIndividualCategoryRequest) => {
  const [data, setData] = useState<any | null>(null);
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [fetchRequest, setFetchRequest] = useState<FetchRequest>();
  const fetchResponse = useFetch(fetchRequest); // Fetch Data Custom Hook
  const apiString = Constants.apiUrl;

  useEffect(() => {
    if (request) {
      let url: string = `${apiString}/api/v1.0/customer-portal/create-category`;

      setFetchRequest({
        url: url,
        method: 'POST',
        body: request
        // body: undefined
      });
    }

  }, [request]);

  useEffect(() => {
    if (fetchResponse.data) {
      const response: any = fetchResponse.data;
      setData(response);
    }

  }, [fetchResponse.data]);

  useEffect(() => {
    if (fetchResponse.error) {
      setError(fetchResponse.error)
      console.log("fetch error");
    }
  }, [fetchResponse.error]);

  useEffect(() => {
    setIsLoading(fetchResponse.isLoading);
  }, [fetchResponse.isLoading]);

  return ({ data, error, isLoading });
}

export default useCreateIndividualCategory;

export interface CreateIndividualCategoryResponse extends FetchResponse {
  category: PaymentAllocationCategory;
}

export interface CreateIndividualCategoryRequest {
  reservationId: number;
}